/**
 * Leave Management Constants
 */

// Leave type colors for calendar and badges
export const LEAVE_TYPE_COLORS = {
  casual: { bg: 'bg-blue-500', text: 'text-blue-600', light: 'bg-blue-100' },
  sick: { bg: 'bg-red-500', text: 'text-red-600', light: 'bg-red-100' },
  earned: { bg: 'bg-emerald-500', text: 'text-emerald-600', light: 'bg-emerald-100' },
  compensatory: { bg: 'bg-purple-500', text: 'text-purple-600', light: 'bg-purple-100' },
  unpaid: { bg: 'bg-slate-500', text: 'text-slate-600', light: 'bg-slate-100' },
};

export const STATUS_COLORS = {
  pending: 'bg-amber-500',
  verified: 'bg-blue-500',
  approved: 'bg-emerald-500',
  rejected: 'bg-red-500',
};

export const VALID_LEAVE_TYPES = ['casual', 'sick', 'earned', 'compensatory', 'unpaid'];
